// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_Fdq","clinicsSelect":"styles_clinicsSelect__dPOm5"};